var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-holder ee"},[_c('v-alert',{staticClass:"alertComponent",attrs:{"type":"error"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataWarn.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }